import { ref } from 'vue';

const employeeSickness = () => {
    const employee_sickness_error = ref(null);
    const employee_sicknesses = ref([]);

    const loadEmployeeSickness = async ( monitor_others, view_locations) => {
        var params = [];
        params.push(['monitor_others',monitor_others]);
        params.push(['view_locations', view_locations]);

        // console.log('params', new URLSearchParams(params));

        try {
            let data = await fetch("/api/employeesicknesses?" + new URLSearchParams(params));

            if (!data.ok) {
                throw Error("Can't load data");
            }

            employee_sicknesses.value = await data.json();

            // console.log('clients', clients.value);
        } catch (err) {
            employee_sickness_error.value = err.message;
        }
    };

    const saveEmployeeSickness = async (sickness) => {
        try {
            let data = await fetch("/api/employeesicknesses");
            if (!data.ok) {
                throw Error("Can't save data");
            }

            //employee_sicknesses.value = await data.json();

            // console.log('clients', clients.value);
        } catch (err) {
            employee_sickness_error.value = err.message;
        }
    };

    return { employee_sicknesses, employee_sickness_error, loadEmployeeSickness, saveEmployeeSickness };
}

export default employeeSickness;
